import React, { ReactElement, useState } from 'react';
import { SyncOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { Button } from 'common/components/antd/Button/Button';
import { Tooltip } from 'common/components/antd/Tooltip/Tooltip';
import { useGetAccountDetailsMutation } from 'domains/accounts/queries/accounts.query';
import { SContainer } from './ActualBalance.styles';

type TProps = {
  counterpartyGUID: string;
  accountGUID: string;
};

const ActualBalanceComponent = (props: TProps): ReactElement => {
  const {
    counterpartyGUID,
    accountGUID,
  } = props;
  const [balance, setBalance] = useState<string | number>('---');
  const { t } = useTranslation();
  const {
    mutateAsync: getAccountDetailsMutation,
    isPending: isGetAccountDetailsLoading
  } = useGetAccountDetailsMutation();

  const onClickHandler = async (): Promise<void> => {
    try {
      const account = await getAccountDetailsMutation({
        counterpartyGUID,
        accountGUID,
      });
      setBalance(account.assets[0].balance);
    } catch (error) {
      console.error(error);
    }
  }

  return <SContainer>
    <Spin spinning={isGetAccountDetailsLoading}>{balance}</Spin>
    <Tooltip title={t('accountManagement.counterpartyEmission.table.column.actualBalance.refreshButtonHint')}>
      <Button
        icon={<SyncOutlined />}
        loading={isGetAccountDetailsLoading}
        onClick={onClickHandler}
      />
    </Tooltip>
  </SContainer>
};

export default ActualBalanceComponent;
